import React, { Component } from "react";
import { getAppMockupsTypes } from "../../../../reduxRelated/actions/diagnosticsActions";
import { CRUDFunction } from "../../../../reduxCURD/container";
import { languageService } from "../../../../Language/language.service";
import { guid } from "../../../../utils/UUID";
import EditableTable from "../../../Common/EditableTable";
import { MyButton } from "../../../Common/Forms/formsMiscItems";
import { ToastService } from "../../../../utils/toastify";
import moment from "moment";
import { blueCardMethods } from "../../../BlueCardReport/BlueCardReportView/HelperMethods";
import { curdActions } from "../../../../reduxCURD/actions";
import _ from "lodash";

class OutOfUseEntries extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editList: [],
      executedPeriodicTestsMap: {},
    };
    this.backup = new Map();
    this.handleActionClick = this.handleActionClick.bind(this);
    this.handleDataChange = this.handleDataChange.bind(this);
    this.addNewRow = this.addNewRow.bind(this);
    this.getColumns = this.getColumns.bind(this);
    this.fetchOutOfUse = this.fetchOutOfUse.bind(this);
    this.timeZone = "America/New_York"; // get from asset location
  }

  getColumns() {
    const { userList, disableCertifiedCheck, showInBlueCardFunctionality, enableEditedByUserColumn } = this.props;
    let list = (userList || []).map((u) => ({ title: u.name, value: u._id }));
    return [
      {
        id: "status",
        header: languageService("Status"),
        type: "text",
        field: "status",
        editable: false,
        minWidth: 150,
      },
      {
        id: "oouStart",
        header: languageService("Start"),
        type: "date",
        field: "start",
        editable: true,
        minWidth: 150,
        dateFormat: "MM/DD/YYYY",
        maxDate: moment().format("MM-DD-YYYY"),
      },
      {
        id: "oouEnd",
        header: languageService("End"),
        type: "date",
        field: "end",
        editable: true,
        minWidth: 200,
        dateFormat: "MM/DD/YYYY",
        maxDate: moment().format("MM-DD-YYYY"),
        clearDateButton: true,
        clearDateButtonLabel: "Leave Open",
      },
      {
        id: "CreditAppliedDate",
        header: languageService("Credit Applied Date"),
        type: "date",
        field: "appliedDate",
        Cell: ({ value }) => {
          if (!value) {
            return "";
          }
          return moment(value).format("MM/DD/YYYY");
        },
        editable: true,
        minWidth: 150,
      },
      {
        id: "noOfDays",
        header: languageService("Total no of Days"),
        type: "text",
        field: "credit",
        editable: true,
        minWidth: 150,
      },

      !disableCertifiedCheck && {
        id: "certifiedBy",
        header: languageService("Certified By"),
        type: "dropdown",
        field: "certifiedBy",
        editable: true,
        minWidth: 150,
        options: [{ value: "", title: "Select" }, ...list],
      },

      enableEditedByUserColumn && {
        id: "manualOutOfUseEntryUser",
        header: languageService("Last Edited By"),
        type: "text",
        accessor: "manualOutOfUseEntryUser.name",
        minWidth: 150,
      },
      !disableCertifiedCheck && {
        id: "certifiedDate",
        header: languageService("Certified Date"),
        type: "date",
        field: "certifiedDate",
        maxDate: moment().format("YYYY-MM-DD"),
        editable: true,
        minWidth: 150,
      },

      showInBlueCardFunctionality && {
        id: "showOnBlueCardCheck",
        header: languageService("Show on Blue Card"),
        type: "bool",
        field: "showOnBlueCardCheck",
        editable: true,
      },

      {
        id: "actions",
        header: languageService("Actions"),
        type: "action",
        immediate: ["Edit", "Delete"],
        editMode: ["Save", "Cancel"],
        nonEditableOptions: null,
        editable: true,
        minWidth: 150,
      },
    ].filter(Boolean);
  }

  fetchOutOfUse() {
    const { getOutOfUseEntriesDatas, assetId, oouEntriesList } = this.props;
    getOutOfUseEntriesDatas && getOutOfUseEntriesDatas(`OutOfUseAsset/OOU_${assetId}`);
  }

  componentDidMount() {
    if (this.props.oouEntriesList && this.props.oouEntriesList.length > 0) {
      this.setState({ editList: this.props.oouEntriesList });
    } else {
      this.fetchOutOfUse();
    }
  }
  componentDidUpdate(prevProps, prevState) {
    const { actionType, OutOfUseEntriesDatas, assetId, testScheduleActionType, getOutOfUseEntriesDatas, oouEntriesList, assetDbOOU } =
      this.props;

    if (!_.isEqual(prevProps.assetDbOOU, assetDbOOU)) {
      this.fetchOutOfUse();
    }

    if (prevProps.actionType !== actionType && actionType === "OUTOFUSEENTRIESDATAS_READ_SUCCESS") {
      const entries =
        OutOfUseEntriesDatas &&
        OutOfUseEntriesDatas[0] &&
        OutOfUseEntriesDatas[0].opt2.map((e) => {
          let obj = { ...e };
          if (e.certified) {
            obj.certifiedDate = e.certified.certifiedDate;
            obj.certifiedBy = e.certified.certifiedBy.name;
          }
          if (!e.status) {
            obj.status = "OPEN";
          }
          obj.credit = this.getCredit(obj);
          return {
            ...obj,
            original: true,
            nonEditable: this.props.allowOpenEntryEdit && !e.end ? false : true,
            ...(this.props.showInBlueCardFunctionality && { showOnBlueCardCheck: obj.certifyReq || obj.overdue ? true : false }),
          };
        });
      this.setState({
        editList: entries || [],
      });
      this.props.updateOOuEntries(entries || []);
      this.props.OOUOnLoadState && this.props.OOUOnLoadState(entries || []);
      let args = `?assetId=${assetId}`;
      let dateToCheck = (entries && entries.length && entries[entries.length - 1].start) || null;
      if (dateToCheck) {
        args = `${args}&date=${dateToCheck}`;
      }
      this.props.getTestSchedules(`executedAssetPeriodicTests${args}`);
    }
    if (prevProps.testScheduleActionType !== testScheduleActionType && testScheduleActionType === "TESTSCHEDULES_READ_SUCCESS") {
      const periodicTestsMap = this.props.testSchedules.reduce((result, val) => {
        const startOfDay = moment(val.date).startOf("day").format("MM/DD/YYYY");
        if (!result[startOfDay]) {
          result[startOfDay] = [val];
        } else {
          result[startOfDay].push(val);
        }

        return result;
      }, {});
      this.setState({ executedPeriodicTestsMap: periodicTestsMap });
    }
  }
  addNewRow() {
    if (this.checkIfEntryIsInEditState()) {
      ToastService.Error("Only one entry can be edited at a time.", "");
      return;
    }

    if (this.checkIfOpenEntryExists()) {
      ToastService.Error("An open entry already exists.", "");
      return;
    }

    const newEntry = {
      id: guid(),
      status: "",
      start: moment().format("YYYY-MM-DD"),
      end: moment().format("YYYY-MM-DD"),
      certifiedBy: "",
      certifiedDate: moment().format("YYYY-MM-DD"),
      editMode: true,
      isNew: true,
      ...(this.props.showInBlueCardFunctionality && { showOnBlueCardCheck: false }),
    };
    this.setState((prevState) => ({
      editList: [...prevState.editList, newEntry],
    }));
  }
  allRequiredEntriesArePresent(newEntry) {
    const { start, certifiedBy, certifiedDate, end } = newEntry;
    if (!start) {
      ToastService.Error("Start date can not be empty.", "");
      return false;
    }

    if (start && end && !this.props.disableCertifiedCheck) {
      if (!certifiedBy) {
        ToastService.Error("Certified By cannot be empty.", "");
        return false;
      }

      if (!certifiedDate) {
        ToastService.Error("Certified Date cannot be empty.", "");
        return false;
      }
    }

    return true;
  }
  handleActionClick(action, rowData) {
    const { editList } = this.state;
    const updatedData = [...editList];
    const rowIndex = updatedData.findIndex((item) => item.id === rowData.id);

    if (rowIndex === -1) return;

    switch (action) {
      case "Edit":
        // Backup the original data
        this.backup.set(rowData.id, { ...rowData });
        if (this.checkIfEntryIsInEditState()) {
          ToastService.Error("Only one entry can be edited at a time.", "");
        } else if (!updatedData[rowIndex].nonEditable) {
          updatedData[rowIndex] = {
            ...rowData,
            end: rowData.end || moment().format("YYYY-MM-DD"),
            ...(this.props.showInBlueCardFunctionality && { showOnBlueCardCheck: updatedData[rowIndex].showOnBlueCardCheck }),
            credit: null,
            editMode: true,
          };
        } else {
          ToastService.Error("This entry cannot be edited.", "");
        }
        break;

      case "Save":
        if (!this.allRequiredEntriesArePresent(updatedData[rowIndex])) {
          return;
        }
        if (!this.canAddEntry(updatedData[rowIndex], editList)) {
          return;
        }
        if (!this.checkIfCreditCanBeApplied(updatedData[rowIndex], editList)) {
          ToastService.Error("Credit can only be applied once.");
          return;
        }
        let credit = this.getCredit(updatedData[rowIndex]);
        let status = updatedData[rowIndex].end ? (credit >= 30 ? "Available" : "Expired") : "OPEN";
        if (this.checkIfAirBrakeInspectionAfterEntry(updatedData[rowIndex])) status = "Cleared";
        let certifiedBy = status === "OPEN" ? "" : updatedData[rowIndex].certifiedBy;
        let certifiedDate = status === "OPEN" ? "" : updatedData[rowIndex].certifiedDate;
        let updated = this.addEntry(
          {
            ...updatedData[rowIndex],
            editMode: false,
            isNew: false,
            status: status,
            credit,
            certifiedBy: certifiedBy,
            certifiedDate: certifiedDate,
          },
          updatedData,
        );
        this.setState({
          editList: updated,
        });
        this.props.updateOOuEntries(updated);

        return;

      case "Cancel":
        if (this.backup.has(rowData.id)) {
          updatedData[rowIndex] = this.backup.get(rowData.id);
          this.backup.delete(rowData.id);
        } else if (rowData.isNew) {
          updatedData.splice(rowIndex, 1);
        }
        break;

      case "Delete":
        if (!updatedData[rowIndex].original) {
          updatedData.splice(rowIndex, 1);
          // Here you would typically delete from your backend
        } else {
          ToastService.Error("This entry cannot be deleted.", "");
        }
        break;

      default:
        break;
    }

    this.setState({ editList: updatedData });
    this.props.updateOOuEntries(updatedData);
  }
  handleDataChange(fieldName, newValue, rowData) {
    const { editList } = this.state;
    const updatedData = editList.map((item) => {
      if (item.id === rowData.id) {
        const updatedObj = { ...item, [fieldName]: newValue };
        return {
          ...updatedObj,
          ...(this.props.showInBlueCardFunctionality && {
            showOnBlueCardCheck:
              fieldName === "showOnBlueCardCheck"
                ? updatedObj.showOnBlueCardCheck
                : this.getCredit({ start: updatedObj.start, end: updatedObj.end || moment().format("YYYY-MM-DD") }) < 30
                  ? updatedObj.showOnBlueCardCheck
                    ? updatedObj.showOnBlueCardCheck
                    : false
                  : null,
          }),
        };
      }
      return item;
    });

    this.setState({ editList: updatedData });
  }
  checkIfEndIsAfter(start, end) {
    if (!end) return true;
    return end.isAfter(start);
  }

  checkIfEndIsSameOrAfter(start, end) {
    if (!end || !start) return true;
    return end.isSameOrAfter(start);
  }

  checkIfSameDay(start, end) {
    if (!end) return false;
    return start.isSame(end, "day");
  }
  hasAnotherOpenEnd(entries) {
    return entries.some((e) => !e.end);
  }
  isOverlapping(newStart, newEnd, start, end) {
    // Both closed intervals
    return !(newEnd.isBefore(start) || newStart.isAfter(end));
  }
  violatesOpenEndedRules(newStart, newEnd, start, end) {
    if (!end) {
      // Existing open-ended
      if (!newEnd) return true;
      if (!newEnd.isBefore(start)) return true;
    } else {
      // Existing closed
      if (!newEnd && !newStart.isAfter(end)) return true;
    }
    return false;
  }

  checkIfPeriodicEntryClashes(start, end, periodicTestsMap) {
    //airbrake cleared check
    let currentDate = _.cloneDeep(moment(start).clone().add(1, "day"));
    while (currentDate.isSameOrBefore(end || new Date())) {
      let currentDateString = moment(currentDate).format("MM/DD/YYYY");
      if (periodicTestsMap[currentDateString]) {
        let found = periodicTestsMap[currentDateString][0];
        ToastService.Error(`${found.title} test execution exists at ${currentDateString}.`, "");
        return true;
      }
      currentDate.add(1, "days");
    }

    return false;
  }
  getCredit(x) {
    return blueCardMethods.calculateOOUDays(Date.parse(x.start) || new Date(), Date.parse(x.end) || new Date());
  }

  canAddEntry(newEntry, entries) {
    let updatedEntry = entries.filter((e) => e.id !== newEntry.id);
    let entryBeforeUpdate = this.backup.get(newEntry.id);
    const tz = this.timeZone;
    const todayDayEnd = moment(new Date()).tz(tz).endOf("day");
    const oldStart = entryBeforeUpdate && moment.tz(entryBeforeUpdate.start, tz);
    const newStart = moment.tz(newEntry.start, tz);
    const newEnd = newEntry.end ? moment.tz(newEntry.end, tz) : null;
    const newCertifiedDate = newEntry.certifiedDate ? moment.tz(newEntry.certifiedDate, tz) : null;

    if (this.checkIfPeriodicEntryClashes(moment.tz(newEntry.start, tz).startOf("day"), newEnd, this.state.executedPeriodicTestsMap)) {
      return false;
    }
    if (newEntry.original && !this.checkIfSameDay(oldStart, newStart)) {
      ToastService.Error("Start date cannot be changed for an existing entry.", "");
      return false;
    }
    if (this.checkIfEndIsAfter(todayDayEnd, newStart)) {
      ToastService.Error("Start date cannot be after today.", "");
      return false;
    }

    if (newEnd && this.checkIfEndIsAfter(todayDayEnd, newEnd)) {
      ToastService.Error("End date cannot be after today.", "");
      return false;
    }
    // if (this.checkIfSameDay(newStart, newEnd)) {
    //   ToastService.Error("Start and end dates cannot be the same.", "");
    //   return false;
    // }
    if (!this.checkIfEndIsSameOrAfter(newStart, newEnd)) {
      ToastService.Error("Start date must be earlier than end date.", "");
      return false;
    }

    if (!this.checkIfEndIsSameOrAfter(newEnd, newCertifiedDate)) {
      ToastService.Error("End date must be earlier than certified date.", "");
      return false;
    }

    if (!newEnd && this.hasAnotherOpenEnd(updatedEntry)) {
      ToastService.Error("Only one open-ended entry is allowed.", "");
      return false;
    }

    for (const e of updatedEntry) {
      const start = moment.tz(e.start, tz);
      const end = e.end ? moment.tz(e.end, tz) : null;

      if (end && newEnd && this.isOverlapping(newStart, newEnd, start, end)) {
        ToastService.Error("This entry conflicts with an existing entry.", "");
        return false;
      }

      if (this.violatesOpenEndedRules(newStart, newEnd, start, end)) {
        ToastService.Error("This entry conflicts with an existing entry.", "");
        return false;
      }

      if (this.getCredit(newEntry) >= 30 && ["Applied"].includes(e.status)) {
        if (newStart.isBefore(start)) {
          ToastService.Error("An available entry cannot be added before an applied entry.", "");
          return false;
        }
      }
      // last available entries must be certified if apply is clicked
      // entry must be checked applied if before an applied entry
    }

    if (this.props.disallowHistoricalEntries) {
      if (updatedEntry.length) {
        let latestEntry = updatedEntry[updatedEntry.length - 1];

        const latestEndDate = moment((latestEntry && latestEntry.end) || new Date())
          .tz(tz)
          .startOf("day");

        if (this.checkIfEndIsSameOrAfter(newStart, latestEndDate)) {
          ToastService.Error("A historical entry cannot be added", "");
          return false;
        }
      }
    }

    return true;
  }

  checkIfAirBrakeInspectionAfterEntry(newEntry) {
    if (!newEntry.end) return false;
    const newEnd = moment.tz(newEntry.end, this.timeZone);
    const clearedTestCodes = ["AirBrakeSys1Lvl3", "AirBrakeSys2Lvl3", "AirBrakeSys3Lvl3", "AirBrakeSys4Lvl3"];
    let periodicTestExecutions = [...this.props.testSchedules];
    for (const test of periodicTestExecutions) {
      if (clearedTestCodes.includes(test.testCode)) {
        const startOfDay = moment.tz(test.date, this.timeZone).startOf("day");
        if (newEnd.isBefore(startOfDay)) return true;
      }
    }

    return false;
  }

  checkIfEntryIsInEditState() {
    if (this.state.editList && this.state.editList.length > 0 && this.state.editList.some((e) => e.editMode === true)) {
      return true;
    }

    return false;
  }

  checkIfOpenEntryExists() {
    if (this.state.editList && this.state.editList.length > 0 && this.state.editList.some((e) => !e.end)) {
      return true;
    }

    return false;
  }
  checkIfCreditCanBeApplied(newEntry, entries) {
    if (!newEntry.applied) return true;
    let updatedEntry = entries.filter((e) => e.id !== newEntry.id);
    let appliedExist = updatedEntry.some((e) => e.applied);
    if (!appliedExist) return true;
    return false;
  }
  addEntry(newEntry, existingEntries) {
    let updated = [...existingEntries].map((e) => {
      if (e.id === newEntry.id) {
        return newEntry;
      } else return e;
    });

    return this.sortEntriesAccordingToDate(updated);
  }
  sortEntriesAccordingToDate(entries) {
    return entries.sort((a, b) => new Date(a.start) - new Date(b.start));
  }

  render() {
    const { editList } = this.state;
    const { renderActions } = this.props;
    return (
      <div>
        {renderActions && renderActions(this.addNewRow)}
        <EditableTable
          columns={this.getColumns()}
          data={editList}
          handleActionClick={this.handleActionClick}
          onChange={this.handleDataChange}
          disableStyle={this.props.disableEditableTableStyle}
        />
        {!this.props.hideNotes && (
          <div style={{ marginLeft: "10px", padding: "3px 5px" }}>
            <span style={{ fontSize: "16px", fontWeight: "bold" }}>Note:</span>{" "}
            <span style={{ fontSize: "14px" }}>
              If the locomotive is out of use at initialization, please ensure that an Open OOU entry is part of the list.
            </span>
          </div>
        )}
      </div>
    );
  }
}

const getTestSchedules = curdActions.getTestSchedules;

let actionOptions = {
  create: false,
  update: false,
  read: true,
  delete: false,
  others: { getTestSchedules },
};
const variables = {
  testScheduleReducer: {
    testSchedules: [],
  },
};
const OutOfUseEntriesContainer = CRUDFunction(
  OutOfUseEntries,
  "OutOfUseEntriesData",
  actionOptions,
  variables,
  ["testScheduleReducer"],
  "applicationlookups",
);
export default OutOfUseEntriesContainer;



// WEBPACK FOOTER //
// ./src/components/AssetView/BlueCard/InitaializeBlueCard/OutOfUseEnteries.jsx